// @flow

export const ERROR_MESSAGE = ['Something went wrong', 'Please try again.'];
